import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
export function Guarantee() {
  return <section className="bg-white px-4 py-5" data-id="element-77" data-mp="1o33tsfx1zqh8">
      <div className="mx-auto max-w-3xl rounded-2xl border border-brand-gold/50 bg-brand-cloud p-4 text-center shadow-sm sm:p-5" data-id="element-78" data-mp="223epbw9b5t8q">
        <p className="mb-1 font-display text-[11px] font-bold uppercase tracking-widest text-brand-navy sm:text-sm" data-id="element-79" data-mp="1x5d4p6w8hlv5">
          IL TUO ACQUISTO È PROTETTO AL 100%
        </p>
        <div className="mx-auto mb-1.5 flex h-12 w-12 items-center justify-center rounded-full bg-brand-sage" data-id="element-80" data-mp="14fxu2i8hduzr">
          <ShieldCheckIcon className="h-6 w-6 text-brand-navy" data-id="element-81" data-mp="1j528rpg2hh34" />
        </div>
        <h2 className="mb-2 font-display text-lg font-extrabold uppercase sm:text-2xl" data-id="element-82" data-mp="1edtzcteqlvpy">
          🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni
        </h2>
        <p className="mx-auto max-w-2xl text-sm font-medium leading-snug text-brand-slate sm:text-base" data-id="element-83" data-mp="qmew8yf4zadn">
          Il tuo acquisto è completamente senza rischi. Hai 14 giorni per esplorare tutti i moduli, utilizzare le valutazioni, i programmi terapeutici, le attività, i protocolli, la documentazione e gli strumenti professionali inclusi in {PRODUCT_NAME}. Se per qualsiasi motivo non sarai completamente soddisfatto, ti basterà contattarci entro 14 giorni e riceverai il rimborso completo. Nessun rischio. Nessuna domanda.
        </p>
      </div>
    </section>;
}